import React, {useRef, useState} from 'react';
import SwiperCore, {Navigation, Pagination, Virtual} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import "swiper/scss";
import "swiper/scss/navigation";
import "./postslider.scss";
import {SwiperRef} from "swiper/react/swiper-react";
import {choosedFile} from "../../dropzone/multiselect/multielectdropzone";

SwiperCore.use([Virtual, Navigation, Pagination]);

interface IPostSlider {
    images: choosedFile[]
}

const PostSlider = ({images}: IPostSlider) => {
    const [slides, setSlides] = useState(
        Array.from({length: 4}).map((_, index) => `Slide ${index}`)
    );
    const sliderRef = useRef<SwiperRef>(null);
    return (
        <div className="Post-Slider">
            <div onClick={() => {
                sliderRef?.current?.swiper.slideNext()
            }} className="Right-Flash"></div>
            <Swiper ref={sliderRef} pagination={{
                type: 'fraction',
            }} dir="ltr" navigation={false} modules={[Navigation]} className="mySwiper">
                {
                    images.length === 0 ?
                        <SwiperSlide>
                            <img src={require("../../../assets/images/photos/Alt.svg").default} alt=""
                                 className="img-fluid"/>
                        </SwiperSlide>
                        :
                        images.map((slideContent, index) => (
                            <SwiperSlide key={slideContent.url} virtualIndex={index}>
                                <img src={slideContent.url} alt="" className="img-fluid"/>
                            </SwiperSlide>
                        ))
                }
            </Swiper>
            <div onClick={() => {
                sliderRef?.current?.swiper.slidePrev();
            }} className="Left-Flash"></div>
        </div>
    );
}


export default PostSlider;